import { api } from 'src/api';
import type { FetchableTableCreationResultWithColumns } from 'src/types';

export const getTickersTableForSymbol = async ({
    symbol,
}: {
    // TODO: Clarify with options/equity type
    symbol: string;
}): Promise<FetchableTableCreationResultWithColumns> => {
    const tableCreationResult = (await api.get(`/tables/tickers/${encodeURIComponent(symbol)}`)).data;
    return {
        ...tableCreationResult,
        fetchMode: 'snapshot',
    };
};

export const getTickersTableForSymbols = async ({
    symbols,
}: {
    symbols: string[];
}): Promise<FetchableTableCreationResultWithColumns> => {
    const tableCreationResult = (await api.post(`/tables/tickers`, { symbols })).data;
    return {
        ...tableCreationResult,
        fetchMode: 'snapshot',
    };
};

export interface PositionTableForAccountAndSymbol {
    pnl: FetchableTableCreationResultWithColumns;
    position: FetchableTableCreationResultWithColumns;
}

export const getPositionTableForAccountAndSymbol = async ({
    symbol,
    accountId,
}: {
    // TODO: Clarify with options/equity type
    symbol: string;
    accountId: string;
}): Promise<PositionTableForAccountAndSymbol> => {
    return (await api.get(`/trading/accounts/${accountId}/position-tables/${encodeURIComponent(symbol)}`)).data;
};

export const getPositionTableForAccountsAndSymbols = async ({
    symbols,
    accountIds,
}: {
    symbols: string[];
    accountIds: string[];
}): Promise<PositionTableForAccountAndSymbol> => {
    return (await api.post(`/trading/position-tables/bulk`, { symbols, accountIds })).data;
};
